import type { ErrorMessage, ErrorCode } from 'src/types';

export enum GraphQLErrorCode {
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  BAD_USER_INPUT = 'BAD_USER_INPUT',
}

export interface I18nErrorPath {
  field: string;
  path: string;
}

export interface DetailedI18nError {
  message: ErrorMessage;
  code: ErrorCode;
  reason: string;
  path: I18nErrorPath;
}

export interface I18nAccountError {
  __typename: string;

  message: ErrorMessage;
  code: ErrorCode;
  reason: string;
  details: DetailedI18nError[];
}
export interface ChangeEmailAddressSuccess {
  __typename: string;
  ref: string;
}

export interface ChangeEmailAddressFailure {
  __typename: string;
  error: I18nAccountError;
}

export interface DeleteAccountSuccess {
  __typename: string;
  ref: string;
}

export interface DeleteAccountFailure {
  __typename: string;
  error: I18nAccountError;
}
export class AuthenticationError extends Error {
  name = 'AuthenticationError';

  constructor() {
    super();
  }
}

export interface ChangeEmailStartSuccess {
  __typename: string;
  ref: string;
}

export interface ChangeEmailStartFailure {
  __typename: string;
  error: I18nAccountError;
}

export interface ChangeEmailVerifySuccess {
  __typename: string;
  ref: string;
}

export interface ChangeEmailVerifyFailure {
  __typename: string;
  error: I18nAccountError;
}
